import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

function toTaskFormData(task, { isUpdate = false } = {}) {
  // Convert task object to multipart FormData with explicit appends (posts.js style),
  // using backend expected keys: formData[...]
  const fd = new FormData();
  const t = task || {};
  const handled = new Set();

  const append = (key, value) => {
    if (typeof value === 'undefined') return;
    fd.append(key, value === null ? '' : value);
  };

  // if (isUpdate) append('_method', 'PUT');

  // Explicit fields (common)
  [
    'id',
    'product',
    'title',
    'description',
    'priority',
    'status',
    'task_type',
    'user_team',
    'assigned_to',
    'qa_to',
    'support_ticket_id',
    'pr_link',
    'due_date',
    'req_due_date',
    'dev_due_date',
    'adh_due_date',
    'extend_due_date',
    'extend_due_date_comment',
  ].forEach((k) => {
    handled.add(k);
    append(`formData[${k}]`, t[k]);
  });

  // Arrays
  handled.add('organizations');
  if (Array.isArray(t.organizations)) {
    t.organizations.forEach((orgId, i) => append(`formData[organizations][${i}]`, orgId));
  }

  // File
  handled.add('document');
  if (t.document) append('formData[document]', t.document);

  // Fallback: include any other keys (keep existing behavior)
  Object.keys(t || {}).forEach((key) => {
    if (handled.has(key)) return;
    const value = t[key];
    if (typeof value === 'undefined') return;

    if (Array.isArray(value)) {
      value.forEach((v, i) => append(`formData[${key}][${i}]`, v));
      return;
    }

    append(`formData[${key}]`, value);
  });

  return fd;
}

function normalizeTaskPayload(payload) {
  if (Array.isArray(payload)) return payload[0];
  if (payload && typeof payload === 'object' && 'formData' in payload) return payload.formData;
  return payload;
}

// initial state
const state = {

  taskCount: 0,
  unnotifiedTasks: [],
  tasks:[],
  task:[],
  status: "",
  search: "",  
  currentPage: 1,
  totalRecords:0,
  totalRows: 0,
  totalPages: 0,
  department:[],
  activityTypes: {
    add: '1',
    edit: '2',
    delete: '3',
    assign: '4',
    extendDueDate: '5',
    changeStatus: '6',
    extendDeveloperDueDate: '7',
    extendADHDueDate: '8',
    developerReport: '9',
    onHoldTask: '10',
    addIssue: '11',

  },
  filters: {},
  sortingBy: {},
  organization_filter:[],
  urgency_filter:'',
  team_filter:'',
  date_range_filter:{},
  statusNames: {
    0: 'Pending',
    1: 'Assigned',
    2: 'In Progress',
    3: 'On Hold',
    4: 'Delivered',
    5: 'In Review',
    10: 'Ready for QA',
    6: 'In QA',
    11: 'Bug Fixing',
    14: 'Bug Fixed',
    12: 'QA Passed',
    13: 'Discussion Pending',
    7: 'PR Review',
    8: 'Unnotified',
    9: 'Ready To Deploy',
      // Add more status names as needed
  },
  prioritiesList:[
    { name: 'Critical', value: '6' },
    { name: 'Urgent', value: '1' },
    { name: 'High', value: '2' },
    { name: 'Medium', value: '3' },
    { name: 'Low', value: '4' },
    { name: 'Lowest', value: '5' },
  ],
  deliveredOptions:[
    { name: 'Delivered', value: ['4'] },
    { name: 'Not Delivered', value: ['0','1','2','3','5','10','6','11','14','12','13','7','8','9']},

  ],
}
const getters = {
    tasks: (state) => {
        return state.tasks;
      },
      task: (state) => {
        return state.task;
      },
      status: (state) => {
        return state.status;
      },
      search: (state) => {
        return state.search;
      },
      currentPage: (state) =>{
        return state.currentPage;
      },
      totalPages: (state) => {
        return state.totalPages;
      },
      totalRows: (state) => {
        return state.totalRows;
      },
      totalRecords: (state) => {
        return state.totalRecords;
      },
      department:(state) =>{
        return state.department;
      },
      organization_filter:(state) =>{
        return state.organization_filter;
      },
      urgency_filter:(state) =>{
        return state.urgency_filter;
      },
      team_filter:(state) =>{
        return state.team_filter;
      },
      date_range_filter:(state) =>{
        return state.date_range_filter;
      },
      filters:(state) =>{
        return state.filters;
      },
      activityTypes:(state) =>{
        return state.activityTypes;
      },
      statusNames:(state) =>{
        return state.statusNames;
      },
      sortingBy:(state) =>{
        return state.sortingBy;
      },
      prioritiesList:(state) =>{
        return state.prioritiesList;
      },
      deliveredOptions:(state) =>{
        return state.deliveredOptions;
      },
      taskTypesList:(state) =>{
        return state.taskTypesList;
      },
}
const mutations = {
  SET_TICKET_COUNT(state, count) {
    state.ticketCount = count;
  },
  SET_UNREAD_TICKETS(state, tickets) {
    state.unreadTickets = tickets;
  },
  SET_TASK_COUNT(state, count) {
    state.taskCount = count;
  },
  SET_UNNOTIFIED_TASKS(state, tasks) {
    state.unnotifiedTasks = tasks;
  },
  SET_TASKS(state, tasks) {
    state.tasks = tasks;
  },
  SET_TASK(state, task) {
    state.task = task;
  },
  SET_SEARCH(state, search){
    state.search = search;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
  SET_CURRENT_PAGE(state,currentPage){
    state.currentPage = currentPage;
  },
  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },
  SET_TOTAL_ROWS(state, totalRows) {
    state.totalRows = totalRows;
  },
  SET_TOTAL_RECORDS(state, totalRecords){
    state.totalRecords = totalRecords;
  },
  SET_DEPARTMENT(state,department){
    state.department = department;
  },
  SET_FILTERS (state, filters) {
    state.filters = filters;
  },
  SET_SORTING_BY (state, sortingBy) {
    state.sortingBy = sortingBy;
  }
}
const actions = {
  async getAll({ commit }, [page, filters, sortingBy]) {
    commit('SET_CURRENT_PAGE',page);
    commit('SET_FILTERS',filters);
    commit('SET_SORTING_BY',sortingBy);
    
    filters.page = page;
    filters.product_id  =  localStorage.getItem('product');
    let requestData = {filters: filters, sortingBy: sortingBy};

    if(hasPermission('task_list')){
      const permission = {
        headers: {
          'X-Permission': 'task_list' // Setting the custom header
        }
      };
      await axios.post('/common/task',requestData,permission).then((response) => {
        let res = response.data
        let totalPages = Math.ceil(res.total / res.per_page);
        let rows= (res.total < res.per_page) ? res.total : res.per_page;

        commit('SET_TASKS',res.data);
        commit('SET_TOTAL_RECORDS',res.total);
        commit('SET_TOTAL_PAGES', totalPages);
        commit('SET_TOTAL_ROWS', rows);
        //return res.data.data;
      });
    }
  },
  async getAllDesignerTask({ commit }, [page, filters, sortingBy]) {
    commit('SET_CURRENT_PAGE',page);
    commit('SET_FILTERS',filters);
    commit('SET_SORTING_BY',sortingBy);

    filters.page = page;
    let requestData = {filters: filters, sortingBy: sortingBy};
    if(hasPermission('designer_task_list')){
      const permission = {
        headers: {
          'X-Permission': 'designer_task_list' // Setting the custom header
        }
      };

      await axios.post('/common/designertask',requestData,permission).then((response) => {
        let res = response.data
        let totalPages = Math.ceil(res.total / res.per_page);
        let rows= (res.total < res.per_page) ? res.total : res.per_page;

        commit('SET_TASKS',res.data);
        commit('SET_TOTAL_RECORDS',res.total);
        commit('SET_TOTAL_PAGES', totalPages);
        commit('SET_TOTAL_ROWS', rows);
        //return res.data.data;
      });
    }

  },

  async add({commit,dispatch}, payload){
    const formData = normalizeTaskPayload(payload);
    if(hasPermission('add_task')){
      const permission = {
        headers: {
          'X-Permission': 'add_task'
        }
      };
      // Send as request body (multipart FormData), not JSON.
      // Important: do NOT set Content-Type manually; axios/browser will set multipart boundary.
      const data = (typeof FormData !== 'undefined' && formData instanceof FormData)
        ? formData
        : toTaskFormData(formData, { isUpdate: false });
      return await axios.post("/common/task/save", data, permission).then(async(res) => {
        return res.data;
      });
    }
  },
  async addTask({ commit}, [formData]) {
    if(hasPermission('designer_add_task')){
      const permission = {
        headers: {
          'X-Permission': 'designer_add_task'
        }
      };
      return await axios.post("/common/designertask/save", { formData },permission).then((res) => {
        // await dispatch('setUnnotifiedTaskCount');
        return res.data;
      });
    }
  },


  async edit({commit},[id]){
    if(hasPermission('edit_task')){
      const permission = {
        headers: {
          'X-Permission': 'edit_task'
        }
      };
      return await axios.get("/common/task/edit/"+id,permission).then((response) => {
        let res = response.data;
        commit('SET_TASK',res.post);
        return res.post;

      });
    }
  },
  async editDesignerTask({commit},[id]){
    if(hasPermission('designer_edit_task')){
      const permission = {
        headers: {
          'X-Permission': 'designer_edit_task'
        }
      };
      return await axios.get("/common/designertask/edit/"+id,permission).then((response) => {
        let res = response.data;
        commit('SET_TASK',res.post);
        return res.post;

      });
    }
  },

  async update({commit}, payload){
    const formData = normalizeTaskPayload(payload);

    if(hasPermission('edit_task')){
      const permission = {
        headers: {
          'X-Permission': 'edit_task'
        }
      };
      // Send as request body (multipart FormData), not JSON.
      // Important: do NOT set Content-Type manually; axios/browser will set multipart boundary.
      const data = (typeof FormData !== 'undefined' && formData instanceof FormData)
        ? formData
        : toTaskFormData(formData, { isUpdate: true });
      return await axios.post("/common/task/"+formData.id, data, permission).then((res) => {
        return res.data;
      });
    }

  },


  async updateTask({commit},[formData]){
    if(hasPermission('designer_edit_task')){
      const permission = {
        headers: {
          'X-Permission': 'designer_edit_task'
        }
      };
      return await axios.post("/common/designertask/"+formData.id,{formData},permission).then((res) => {
        return res.data;
      });
    }

  },

  async assign({commit},[formData]){
    if(hasPermission('view_task_assign_to')){
      const permission = {
        headers: {
          'X-Permission': 'view_task_assign_to'
        }
      };
      return await axios.post("/common/task/assign/"+formData.id,{formData},permission).then((res)=>{
        return res.data;
      });
    }

  },

  async assignDesignerTask({commit},[formData]){
    if(hasPermission('designer_view_task_assign_to')){
      const permission = {
        headers: {
          'X-Permission': 'designer_view_task_assign_to'
        }
      };
      return await axios.post("/common/designertask/assign/"+formData.id,{formData},permission).then((res)=>{
        return res.data;
      });
    }
  },

  async delete({commit,dispatch},[id]){
    if(hasPermission('delete_task')){
      const permission = {
        headers: {
          'X-Permission': 'delete_task'
        }
      };
      return await axios.delete("/common/task/"+id,permission).then(async(response) => {
        let res = response.data;
        commit('SET_TASK',res.post);
        await dispatch('setUnnotifiedTaskCount');
        return res.post;

      });
    }
  },

  async deleteDesignerTask ({ commit }, [id]) {
    if(hasPermission('designer_delete_task')){
      const permission = {
        headers: {
          'X-Permission': 'designer_delete_task'
        }
      };
      return await axios.delete("/common/designertask/" + id,permission).then((response) => {
        let res = response.data;
        commit('SET_TASK', res.post);
        return res.post;
      });
    }
},
//   async delete({ commit }, [id]) {
//     return await axios.delete("/common/task/" + id).then(async (response) => {
//         let res = response.data;
//         commit('SET_TASK', res.post);
//         await dispatch('setUnnotifiedTaskCount');
//         return res.post;
//     });
// },
  async extendDueDate({commit},[formData]){
    if(hasPermission(formData.prms)){
      const permission = {
        headers: {
          'X-Permission': formData.prms,
        }
      };
      return await axios.post("/common/task/extend-due-date/"+formData.id,{formData},permission).then((res)=>{
        return res.data;
      });
    }
  },

  async extendDueDateDesignerTask({commit},[formData]){
    if(hasPermission(formData.prms)){
      const permission = {
        headers: {
          'X-Permission': formData.prms,
        }
      };
      return await axios.post("/common/designertask/extend-due-date/"+formData.id,{formData},permission).then((res)=>{
        return res.data;
      });
    }

  },
  async developerReport({commit},{formData}){
    if(hasPermission(formData.prms)){
      const permission = {
        headers: {
          'X-Permission': formData.prms,
        }
      };
      return await axios.post("/common/task/developer-report",{formData},permission).then((res)=>{
        return res.data;
      });
    }
  },
  async taskIssue({commit},{formData}){
    if(hasPermission('task_issue')){
      const permission = {
        headers: {
          'X-Permission': 'task_issue'
        }
      };
      return await axios.post("/common/task/task-issue",{formData},permission).then((res)=>{
        return res.data;
      });
    }
  },
  async updateTaskIssue({},{formData}){
    if(hasPermission('task_issue')){
      const permission = {
        headers: {
          'X-Permission': 'task_issue'
        }
      };
      return await axios.post("/common/task/update-task-issue-status",{formData},permission).then((res)=>{
        return res.data;
      });
    }
  },
  async prevReport({commit},{task_id,prms,}){
    if(hasPermission(prms)){
      const permission = {
        headers: {
          'X-Permission': prms,
        }
      };
      return await axios.get("/common/task/today-report/"+task_id,permission).then((res)=>{

        return res.data.reports;
      });
    }
  },
  async prevReportByDate({commit},{task_id,pdate,prms,}){
    if(hasPermission(prms)){
      const permission = {
        headers: {
          'X-Permission': prms,
        }
      };
      return await axios.get("/common/task/today-report/"+task_id+"/"+pdate,permission).then((res)=>{

        return res.data.reports;
      });
    }
  },
  async getActivity({commit},[id, type = '']){
    if(hasPermission('view_task_extend_due_date_history')){
      const permission = {
        headers: {
          'X-Permission': 'view_task_extend_due_date_history'
        }
      };
      return await axios.get("/common/task/activity/"+id, {params: {type: type}, headers: permission.headers}).then((res) => {
        return res.data.data;
      });
    }
  },
  async getdesignerActivity({commit},[id, type = '']){
    if(hasPermission('designer_view_task_extend_due_date_history')){
      const permission = {
        headers: {
          'X-Permission': 'designer_view_task_extend_due_date_history'
        }
      };
      return await axios.get("/common/designertask/activity/"+id, {params: {type: type}, headers: permission.headers}).then((res) => {
        return res.data.data;
      });
    }
  },
  async view({commit},[id]){
    if(hasPermission('view_task')){
      const permission = {
        headers: {
          'X-Permission': 'view_task'
        }
      };
      return await axios.get("/common/task/"+id,permission).then((response)=>{
        let res = response.data;
        commit('SET_TASK',res.post);
        return res.post;
      });
    }
  },
    async updateNotificationStatus({ commit, dispatch }, id) {
      if(hasPermission('view_task_is_notified')){
        const permission = {
          headers: {
            'X-Permission': 'view_task_is_notified'
          }
        };
        try {
          const response = await axios.post("/common/task/notification-status/" + id, {},permission);
          const message = response.data.message;
          await dispatch('setUnnotifiedTaskCount');
          return message;
        } catch (error) {
          console.error('Error fetching ticket:', error);
          throw error;
        }
      }
    },

    async viewDesignerTask({commit},[id]){
      if(hasPermission('designer_view_task')){
        const permission = {
          headers: {
            'X-Permission': 'designer_view_task'
          }
        };
        return await axios.get("/common/designertask/"+id,permission).then((response)=>{
          let res = response.data;
          commit('SET_TASK',res.post);
          return res.post;
        });
      }
    },

      async getTeamsList({commit},){
        return axios.get("/team/all").then((response) => {
          return response.data.posts;
        });
      },
      async getCurrentDueDate({commit},[id]){
        return await axios.get("/admin/users/get-current-due-date/"+id).then((response)=>{
          return response.data.data;
        });
      },
      async updateStatus({commit},[formData]){
        if(hasPermission(formData.prms)){
          const permission = {
            headers: {
              'X-Permission': formData.prms

            }
          };
          return await axios.post("/common/task/change-status/"+formData.id,{formData},permission).then((response)=>{
            return response.data.message;
          });
        }
      },

      async updateStatusDesignerTask({commit},[formData]){
        if(hasPermission(formData.prms)){
          const permission = {
            headers: {
              'X-Permission':formData.prms
            }
          };
          return await axios.post("/common/designertask/change-status/"+formData.id,{formData},permission).then((response)=>{
            return response.data.message;
          });
        }
      },
      async viewTask({commit},[id]){
        return await axios.get("/admin/users/view-task/"+id).then((response)=>{
          return response.data;
        });
      },
      async setUnnotifiedTaskCount({ commit }) {
        if(hasPermission('add_task')){
          const permission = {
            headers: {
              'X-Permission': 'add_task' // Setting the custom header
            }
          };
          const response = await axios.get('/admin/support/unnotified-task-count',permission);
          if (response.data.task_count) {
            commit('SET_TASK_COUNT', response.data.task_count);
            commit('SET_UNNOTIFIED_TASKS', response.data.tasks);

          }
        }
      }
}
 
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }